import { z } from 'zod';

export const onboardingSchema = z.object({
  organization: z.object({
    slug: z.string(),
    companyId: z.coerce.number().optional(),
  }),
});

export type OnboardingSchema = z.infer<typeof onboardingSchema>;
